// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"2d68930c","977":"7acd9525"}[chunkId] + ".chunk.js";
};